import React from 'react';
import { Route, BrowserRouter as Router, Switch, withRouter } from 'react-router-dom';

//Custom Components

import HomeTwelveOnePage from '../pages/onepage-12';
import Error from '../pages/404';
import LoadTop from '../components/Common/ScrollTop/LoadTop'

const App = () => {
    return (
        <div className='App'>
            <Router>  
                <LoadTop />          
                <Switch>
                    <Route path="/" exact component={HomeTwelveOnePage} />
                    <Route path="/onepage-12" component={HomeTwelveOnePage} />
                    <Route component={Error} />
                </Switch>
            </Router>
            
        </div>
    );
}

export default App;
